// @flow
import React, { Component } from "react";
import Link from "gatsby-link";
import { prettyDate } from "../../../utils/helpers";
import CompanyLogo from "../../shared/CompanyLogo/CompanyLogo";
import SeverityRating from "../../shared/SeverityRating/SeverityRating";
import container from "../../../styles/container.module.css";
import styles from "./BreachItem.module.css";

type Props = {
  uid: string,
  title: string,
  companyName: string,
  companyUrl: string,
  disclosedAt: string,
  attackVector: string,
  severity: number
};

class BreachItem extends Component<Props, void> {
  render() {
    const {
      uid,
      title,
      companyName,
      companyUrl,
      disclosedAt,
      attackVector,
      severity
    } = this.props;
    return (
      <li className={styles.item}>
        <div className={container.default}>
          <Link className={styles.link} to={uid}>
            <div className={styles.flexSection}>
              <div className={styles.logoWrapper}>
                <CompanyLogo
                  className={styles.logo}
                  companyName={companyName}
                  companyUrl={companyUrl}
                />
              </div>
              <h4 className={styles.title}>{title}</h4>
            </div>
            <div className={`${styles.flexSection} ${styles.meta}`}>
              <div className={styles.flexSection}>
                {prettyDate(disclosedAt)}
              </div>
              <div className={styles.flexSection}>{attackVector}</div>
              <div className={styles.flexSection}>
                <SeverityRating severity={severity} />
              </div>
            </div>
          </Link>
        </div>
      </li>
    );
  }
}

export default BreachItem;



// WEBPACK FOOTER //
// ./src/components/Landing/BreachItem/BreachItem.js